<template>
    <div>
        <van-field
                v-model.trim="message"
                rows="10"
                autosize
                type="textarea"
                placeholder="请输入跟进记录"
        />
        <div style="display: flex;align-items: center;justify-content: center;padding: 16px">
            <van-button plain type="primary" @click="goBack">返回</van-button>
            <van-button style="margin-left: 16px" type="primary" @click="save">保存</van-button>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {message: "", ExternalUserId: ""}
    },
    created() {
        const route = this.$route;
        this.ExternalUserId = route.query.ExternalUserId
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        async save() {
            if (!this.message || this.message.length == 0) {
                vant.Toast('请输入跟进内容');
                return
            }
            await this.$dialog.confirm({
                title: "温馨提示",
                message: '是否保存跟进内容？',
            });
            await this.$frame.postBusiness("WXExternalUserFollowMemo", {
                Memo: this.message,
                ExternalUserId: this.ExternalUserId
            })
            this.$router.back()
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
